<template>
  <v-tooltip bottom content-class="tooltip-bottom" :nudge-bottom="4" :disabled="$vuetify.breakpoint.smAndDown">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" style="display: inline-block;">
        <router-link
          v-if="to"
          :to="to"
          class="ism-action-btn"
          :class="variantClass"
        >
          <v-icon :size="iconSize">{{ icon }}</v-icon>
        </router-link>
        <button
          v-else
          class="ism-action-btn"
          :class="variantClass"
          @click="$emit('click')"
        >
          <v-icon :size="iconSize">{{ icon }}</v-icon>
        </button>
      </div>
    </template>
    <span>{{ label }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'PremiumActionButton',
  props: {
    icon: { type: String, required: true },
    label: { type: String, required: true },
    to: { type: [String, Object], default: null },
    variant: { type: String, default: 'default' }, // default, success, danger, warning, info
    iconSize: { type: [Number, String], default: 16 }
  },
  computed: {
    variantClass() {
      if (this.variant === 'default') return '';
      return `ism-action-${this.variant}`;
    }
  }
}
</script>
